import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { getReportDashboardWidgets } from '../../api';

function formatCurrency(value) {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
  return `$${value}`;
}

function formatMonth(period) {
  if (!period) return '';
  const [, month] = period.split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[parseInt(month) - 1] || '';
}

export default function MiniRevenueChart({ widgetData }) {
  const data = widgetData?.revenueTrend || [];

  if (data.length === 0) {
    return <div className="mini-chart-empty">No revenue data</div>;
  }

  return (
    <div className="mini-chart-container">
      <ResponsiveContainer width="100%" height={180}>
        <AreaChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <XAxis dataKey="period" tickFormatter={formatMonth} tick={{ fontSize: 10, fill: 'var(--color-text-secondary)' }} />
          <YAxis tickFormatter={formatCurrency} tick={{ fontSize: 10, fill: 'var(--color-text-secondary)' }} width={50} />
          <Tooltip formatter={(v) => formatCurrency(v)} labelFormatter={formatMonth} />
          <Area type="monotone" dataKey="revenue" stroke="#22c55e" fill="#22c55e" fillOpacity={0.15} strokeWidth={2} />
        </AreaChart>
      </ResponsiveContainer>
      <Link to="/reports?type=revenue" className="mini-chart-link">View Full Report</Link>
    </div>
  );
}
